import { Component, ViewChild } from '@angular/core';
import { Platform, Nav } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Auth } from '../providers/auth';
import { LoadingController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Events } from 'ionic-angular';

/* --- PAGES --- */
import { AboutPage } from '../pages/about/about';
import { CollectiblesPage } from '../pages/collectibles/collectibles';
import { HomePage } from '../pages/home/home';
import { SettingsPage } from '../pages/settings/settings';
import { VersusPage } from '../pages/versus/versus';
import { SurveyPage } from '../pages/survey/survey';
import { LoginPage } from '../pages/login/login';
import { HowToPage } from '../pages/howto/howto';
import { RankingsPage } from '../pages/rankings/rankings';

import { ProfilePage } from '../pages/profile/profile';

import { Functions } from '../providers/functions';
import { IntroPage } from '../pages/intro/intro';

@Component({
  templateUrl: 'app.html',
  providers: []
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage:any;
  loader:any;

  pages: Array<{title: string, component: any, icon: string, functionORpage: string}>;
  activePage: any;
  defaultLanguage:string ='en'; // it o en

  constructor(platform: Platform, public events: Events, statusBar: StatusBar, splashScreen: SplashScreen, public auth: Auth, public loadingCtrl: LoadingController, public functions: Functions, public translate: TranslateService) {
    statusBar.hide();
    statusBar.overlaysWebView(false);
    this.functions.language=this.defaultLanguage;
    this.functions.setLanguage();
    translate.setDefaultLang(this.functions.language);
    translate.use(this.functions.language);
    
    platform.ready().then(() => {
      // As the app is ready hide the splash screen
      splashScreen.hide();

      /* The menu html is in app.html */
      this.pages = [ //ribbon heart
        { title: 'Play', component: HomePage, icon: 'paw', functionORpage:'page' },
        { title: 'Gamemode', component: VersusPage, icon: 'flask', functionORpage:'page' },
        { title: 'Rankings', component: RankingsPage, icon: 'ribbon', functionORpage:'page' },
        { title: 'Settings', component: SettingsPage, icon: 'settings', functionORpage:'page' },
        { title: 'How to Play', component: HowToPage, icon: 'help', functionORpage:'page' },
        //{ title: 'Collectibles', component: CollectiblesPage, icon: 'trophy', functionORpage:'page' },
        { title: 'Profile', component: ProfilePage, icon: 'image', functionORpage:'' },
        //{ title: 'Survey', component: SurveyPage, icon: 'create', functionORpage:'' },
        { title: 'About', component: AboutPage, icon: 'people', functionORpage:'page' }
        //{ title: 'Logout', component: AboutPage, icon: 'power', functionORpage:'logout' }
      ];

      this.loadLangStringMenu();
      this.activePage = this.pages[0];

      // tenta login automatico
      //this.presentLoading();
      //TODO add username e password presi da qualche parte
      //this.auth.login("efalivene_plr","",true).then((response)=>{
      /*this.auth.login("","",true).then((response)=>{
        var responseString:string;
        responseString=response.toString();
        if(responseString.indexOf('loginResIsOk')!=-1){
           this.rootPage=HomePage;
        }else{
          this.rootPage=LoginPage;
        }
        this.loader.dismiss();
      });*/
      this.rootPage=LoginPage;
    });

    // This events is called in functions when the language changes.
    // This way I can change menu language accordingly to the changes calling
    // again loadLangStringMenu which modify menu Title with the new language set in
    // functions setLanguage
    events.subscribe('menu:langChanged', () => {
      this.loadLangStringMenu();
    });
  }

  loadLangStringMenu(){
    this.translate.get('homeMenu').subscribe(value => { this.pages[0].title = value;});
    this.translate.get('gamemodeMenu').subscribe(value => { this.pages[1].title = value;});
    this.translate.get('rankingsMenu').subscribe(value => { this.pages[2].title = value;});
    this.translate.get('settingsMenu').subscribe(value => { this.pages[3].title = value;});
    this.translate.get('howtoMenu').subscribe(value => { this.pages[4].title = value;});
    //this.translate.get('collectiblesMenu').subscribe(value => { this.pages[5].title = value;});
    this.translate.get('profileMenu').subscribe(value => { this.pages[5].title = value;});
    //this.translate.get('surveyMenu').subscribe(value => { this.pages[6].title = value;});
    this.translate.get('aboutMenu').subscribe(value => { this.pages[6].title = value;});
    //this.translate.get('logout').subscribe(value => { this.pages[7].title = value;});
  }

  presentLoading() {
    this.translate.get('loading').subscribe(value => { 
      this.loader = this.loadingCtrl.create({
        content: value
      });
      this.loader.present();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    /*if(page.functionORpage=='logout'){
      this.logoutCurrentProfile();
    }else{*/
      this.nav.setRoot(page.component);
      this.activePage = page;
    //}
  }

  checkActive(page){
    return page == this.activePage;
  }

  logoutCurrentProfile(){
    if(this.functions.deviceIsOnline()){
      this.presentLoading();
        this.auth.logout().then((response)=>{
          var responseString:string;
          responseString=response.toString();
          if(responseString.indexOf('LogoutIsOk')!=-1){
            this.loader.dismiss();
            this.nav.setRoot(LoginPage, {});
           }else{
             //this.errorMessage=this.auth.errorMessage;
             this.loader.dismiss();
             return;
          }
        });
    }else{
      //translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts